export const MOCK_ORDERS = {
  data: [
    {
      billing_first_name: 'Alex',
      billing_last_name: 'Marques',
      billing_email: 'asd@asf.asf',
      source: {
        title: 'Journey: Alex ikom',
        href: '/app/journey-builder/journeys/998b70e0-0407-11f0-94e4-cd04360f35f1'
      },
      journey_data: {
        Verfügbarkeitsprüfung: {
          countryCode: 'DE',
          city: 'Koblenz',
          zipCode: '56070',
          _isValid: true
        },
        Jahresverbrauch: {
          numberInput: '3000',
          numberUnit: 'kwh',
          _isValid: true
        }
      },
      payment_method: [
        {
          type: 'payment_invoice',
          label: 'Überweisung',
          _isValid: true
        }
      ],
      delivery_address: [
        {
          country: 'DE',
          city: 'Koblenz',
          _tags: ['billing', 'delivery'],
          street: 'Am Alten Hospital',
          street_number: '123',
          _id: '474SbZ6haoajlAX3JVDJd',
          postal_code: '56068'
        }
      ],
      billing_address: [
        {
          country: 'DE',
          city: 'Koblenz',
          _tags: ['billing', 'delivery'],
          street: 'Am Alten Hospital',
          street_number: '123',
          _id: 'kIRGQKpRC-VwehZTNuNo2',
          postal_code: '56068'
        }
      ],
      currency: 'EUR',
      _files: {
        $relation: [
          {
            entity_id: '223638e9-b3c6-44d0-9589-ee26f0f14d9b'
          },
          {
            entity_id: 'cfc7216f-c691-41c6-ae20-2014a2b6b612'
          },
          {
            entity_id: '2178bcf5-5184-4d0b-9675-c502095baa46'
          },
          {
            entity_id: '565710ca-40fe-4a40-a45f-225617467ea4'
          },
          {
            entity_id: '6b579e3a-9be0-4d2c-b142-c3b0bee41e18'
          },
          {
            entity_id: '97c06445-c28c-4eb4-8585-3e190575327a'
          },
          {
            entity_id: 'dbe42176-1a81-4e56-b48c-06c7e5269024'
          }
        ]
      },
      status: 'cancelled',
      source_id: '998b70e0-0407-11f0-94e4-cd04360f35f1',
      source_type: 'journey',
      additional_addresses: [],
      tags: [],
      metadata: [
        {
          key: '_origin',
          value: 'journey checkout'
        }
      ],
      _tags: [],
      line_items: [
        {
          price_id: '933c64f9-4e39-465a-ae00-768d5e525c97',
          product_id: 'edc72ca3-d965-4db1-b6b6-5421b552f808',
          quantity: 1,
          description: '[Graduated] - Consumption II 2',
          unit_amount: 0,
          unit_amount_decimal: '0.00',
          pricing_model: 'per_unit',
          item_components: [
            {
              price_id: '004a11ee-8fcf-4ba3-b0e0-92d7443ce7a1',
              product_id: 'edc72ca3-d965-4db1-b6b6-5421b552f808',
              quantity: 1,
              description: '[Graduated] - Consumption II 1',
              unit_amount: 0,
              unit_amount_decimal: '0',
              pricing_model: 'tiered_graduated',
              _price: {
                _id: '004a11ee-8fcf-4ba3-b0e0-92d7443ce7a1',
                _manifest: ['ed0984d4-c46d-4ed0-844b-dc06cf1ee2a2'],
                _tags: [],
                active: true,
                billing_duration_unit: 'months',
                description: '[Graduated] - Consumption II 1',
                is_tax_inclusive: false,
                long_description: 'component description',
                notice_time_unit: 'months',
                price_display_in_journeys: 'show_price',
                pricing_model: 'tiered_graduated',
                renewal_duration_unit: 'months',
                tax: [
                  {
                    _manifest: [
                      '956e9f44-0d8e-4d50-af85-e528fb130d64',
                      '23af06ca-f23c-4325-969a-a45ae3f96c19'
                    ],
                    _schema: 'tax',
                    active: true,
                    description: '19%',
                    rate: '19',
                    region: 'DE',
                    type: 'VAT',
                    _id: '89a8fa55-b850-474e-9110-ae4a14aec6e2',
                    _org: '739224',
                    _owners: [
                      {
                        org_id: '739224',
                        user_id: '10010729'
                      }
                    ],
                    _created_at: '2025-03-06T07:30:25.408Z',
                    _updated_at: '2025-03-06T07:30:25.408Z',
                    _title: '19%',
                    _acl: {
                      view: ['org_739224'],
                      edit: ['org_739224'],
                      delete: ['org_739224']
                    }
                  }
                ],
                termination_time_unit: 'months',
                tiers: [
                  {
                    flat_fee_amount: 0,
                    flat_fee_amount_decimal: '0',
                    unit_amount: 14,
                    unit_amount_decimal: '0.14',
                    up_to: 1000
                  },
                  {
                    flat_fee_amount: 0,
                    flat_fee_amount_decimal: '0',
                    unit_amount: 5,
                    unit_amount_decimal: '0.054',
                    up_to: 2000
                  },
                  {
                    flat_fee_amount: 0,
                    flat_fee_amount_decimal: '0',
                    unit_amount: 5,
                    unit_amount_decimal: '0.053',
                    up_to: 3000
                  },
                  {
                    flat_fee_amount: 0,
                    flat_fee_amount_decimal: '0',
                    unit_amount: 5,
                    unit_amount_decimal: '0.05'
                  }
                ],
                type: 'recurring',
                unit: 'kwh',
                unit_amount: 0,
                unit_amount_currency: 'EUR',
                unit_amount_decimal: '0',
                variable_price: true,
                billing_period: 'weekly',
                internal_description: '[Graduated] - Consumption II',
                _title: '[Graduated] - Consumption II 1'
              },
              _product: {
                _manifest: ['9d4fc066-64c9-48af-9245-4e47c5d1e8f2'],
                _purpose: ['d6c77db1-aa76-44b2-b021-6e540a367d91'],
                _tags: ['Commodity', 'Strom'],
                active: true,
                categories: [],
                description: 'Außerhalb der Grundversorgung',
                feature: [
                  {
                    _id: 'Y_QjVZ9MHTf8KCp4RFBeW',
                    _tags: [],
                    feature: '100% Ökostrom',
                    value: ''
                  },
                  {
                    _id: 'N7NMWrgGgYqmIHs-Jt6Hq',
                    _tags: [],
                    feature: 'Erstlaufzeit bis 31.12.2025',
                    value: ''
                  },
                  {
                    _id: 'SbRtgtY6flxvlR1M-LaHi',
                    _tags: [],
                    feature: 'Kündigungsfrist 1 Monat',
                    value: ''
                  },
                  {
                    _id: 'v07rw_RfinlcUOfQD0h9S',
                    _tags: [],
                    feature:
                      '100 % Preisgarantie auf den Energiepreis (ausgenommen Netzentgelte, Umlagen/Steuern)',
                    value: ''
                  }
                ],
                internal_name: 'Dummy - Strom Commodity',
                name: 'Dummy - Strom Commodity 1',
                price_options: [
                  {
                    _id: '1793cd14-258e-4d6f-b13e-82e093dfd102',
                    _manifest: ['9d4fc066-64c9-48af-9245-4e47c5d1e8f2'],
                    _purpose: ['d6c77db1-aa76-44b2-b021-6e540a367d91'],
                    _schema: 'price',
                    _tags: ['Commodity', 'Strom'],
                    active: true,
                    description: 'Dummy - Commodity Strom',
                    is_composite_price: true,
                    is_tax_inclusive: null,
                    price_components: [],
                    price_display_in_journeys: 'show_price',
                    pricing_model: null,
                    tiers: [],
                    type: null,
                    unit_amount: 0,
                    unit_amount_currency: 'EUR',
                    unit_amount_decimal: '0.00',
                    variable_price: null,
                    billing_duration_amount: null,
                    billing_duration_unit: null,
                    billing_period: null,
                    internal_description: 'Dummy - Commodity Strom',
                    notice_time_amount: null,
                    notice_time_unit: null,
                    renewal_duration_amount: null,
                    renewal_duration_unit: null,
                    termination_time_amount: null,
                    termination_time_unit: null,
                    unit: null,
                    _org: '739224',
                    _owners: [
                      {
                        org_id: '739224',
                        user_id: '10010729'
                      }
                    ],
                    _created_at: '2025-04-04T13:46:39.551Z',
                    _updated_at: '2025-04-04T13:46:39.551Z',
                    _title: 'Dummy - Commodity Strom',
                    _acl: {
                      view: ['org_739224'],
                      edit: ['org_739224'],
                      delete: ['org_739224']
                    },
                    $relation: {
                      entity_id: '1793cd14-258e-4d6f-b13e-82e093dfd102',
                      _schema: 'price'
                    }
                  },
                  {
                    _id: 'b239bbfd-2bf7-43b3-84c0-ba389d059fb3',
                    _manifest: ['9d4fc066-64c9-48af-9245-4e47c5d1e8f2'],
                    _purpose: ['d6c77db1-aa76-44b2-b021-6e540a367d91'],
                    _schema: 'price',
                    _tags: ['Commodity', 'Strom'],
                    active: true,
                    billing_duration_unit: 'months',
                    description: 'Dummy - Commodity Strom dynamisch',
                    is_composite_price: true,
                    is_tax_inclusive: true,
                    notice_time_unit: 'months',
                    price_components: [],
                    price_display_in_journeys: 'show_price',
                    pricing_model: 'per_unit',
                    renewal_duration_unit: 'months',
                    termination_time_unit: 'months',
                    tiers: [],
                    type: 'one_time',
                    unit_amount: 0,
                    unit_amount_currency: 'EUR',
                    unit_amount_decimal: '0.00',
                    variable_price: false,
                    billing_period: 'weekly',
                    internal_description: 'Dummy - Commodity Strom dynamisch',
                    _org: '739224',
                    _owners: [
                      {
                        org_id: '739224',
                        user_id: '10010729'
                      }
                    ],
                    _created_at: '2025-04-04T13:46:40.812Z',
                    _updated_at: '2025-04-04T13:46:40.812Z',
                    _title: 'Dummy - Commodity Strom dynamisch',
                    _acl: {
                      view: ['org_739224'],
                      edit: ['org_739224'],
                      delete: ['org_739224']
                    },
                    $relation: {
                      entity_id: 'b239bbfd-2bf7-43b3-84c0-ba389d059fb3',
                      _schema: 'price'
                    }
                  },
                  {
                    _id: '004a11ee-8fcf-4ba3-b0e0-92d7443ce7a1',
                    _manifest: ['ed0984d4-c46d-4ed0-844b-dc06cf1ee2a2'],
                    _schema: 'price',
                    _tags: [],
                    active: true,
                    billing_duration_unit: 'months',
                    description: '[Graduated] - Consumption II 1',
                    is_tax_inclusive: false,
                    long_description: 'component description',
                    notice_time_unit: 'months',
                    price_display_in_journeys: 'show_price',
                    pricing_model: 'tiered_graduated',
                    renewal_duration_unit: 'months',
                    tax: [],
                    termination_time_unit: 'months',
                    tiers: [
                      {
                        flat_fee_amount: 0,
                        flat_fee_amount_decimal: '0',
                        unit_amount: 14,
                        unit_amount_decimal: '0.14',
                        up_to: 1000
                      },
                      {
                        flat_fee_amount: 0,
                        flat_fee_amount_decimal: '0',
                        unit_amount: 5,
                        unit_amount_decimal: '0.054',
                        up_to: 2000
                      },
                      {
                        flat_fee_amount: 0,
                        flat_fee_amount_decimal: '0',
                        unit_amount: 5,
                        unit_amount_decimal: '0.053',
                        up_to: 3000
                      },
                      {
                        flat_fee_amount: 0,
                        flat_fee_amount_decimal: '0',
                        unit_amount: 5,
                        unit_amount_decimal: '0.05'
                      }
                    ],
                    type: 'recurring',
                    unit: 'kwh',
                    unit_amount: 0,
                    unit_amount_currency: 'EUR',
                    unit_amount_decimal: '0',
                    variable_price: true,
                    _acl_sync: '2025-03-11T13:48:28.862Z',
                    billing_period: 'monthly',
                    internal_description: '[Graduated] - Consumption II',
                    _org: '739224',
                    _owners: [
                      {
                        org_id: '739224',
                        user_id: '11000933'
                      }
                    ],
                    _created_at: '2024-09-26T13:05:59.823Z',
                    _updated_at: '2025-04-08T06:37:49.442Z',
                    _title: '[Graduated] - Consumption II 1',
                    _acl: {
                      view: ['org_739224', 'org_911675'],
                      edit: ['org_739224'],
                      delete: ['org_739224']
                    },
                    $relation: {
                      entity_id: '004a11ee-8fcf-4ba3-b0e0-92d7443ce7a1',
                      _schema: 'price',
                      _tags: []
                    }
                  },
                  {
                    _id: '933c64f9-4e39-465a-ae00-768d5e525c97',
                    description: '[Graduated] - Consumption II 2',
                    internal_description: '[Graduated] - Consumption II 2',
                    pricing_model: 'per_unit',
                    unit_amount: 0,
                    unit_amount_currency: 'EUR',
                    unit_amount_decimal: '0.00',
                    is_tax_inclusive: true,
                    price_display_in_journeys: 'show_price',
                    active: true,
                    type: 'one_time',
                    billing_duration_unit: 'months',
                    notice_time_unit: 'months',
                    termination_time_unit: 'months',
                    renewal_duration_unit: 'months',
                    is_composite_price: true,
                    price_components: [],
                    _tags: ['composite'],
                    _schema: 'price',
                    _org: '739224',
                    _owners: [
                      {
                        org_id: '739224',
                        user_id: '11001058'
                      }
                    ],
                    _created_at: '2025-04-08T06:45:31.550Z',
                    _updated_at: '2025-04-08T06:45:31.550Z',
                    billing_period: 'weekly',
                    _title: '[Graduated] - Consumption II 2',
                    _acl: {
                      view: ['org_739224'],
                      edit: ['org_739224'],
                      delete: ['org_739224']
                    },
                    $relation: {
                      entity_id: '933c64f9-4e39-465a-ae00-768d5e525c97',
                      _tags: []
                    }
                  }
                ],
                product_downloads: [
                  {
                    _id: '2767d43f-5ecf-437f-81ca-90eb71880a98',
                    _manifest: ['9d4fc066-64c9-48af-9245-4e47c5d1e8f2'],
                    _purpose: [],
                    _tags: ['Commodity', 'Datenschutz'],
                    _title: 'Datenschutzinformationen.pdf',
                    access_control: 'public-read',
                    filename: 'Datenschutzinformationen.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-dev-user-content.s3.eu-central-1.amazonaws.com/739224/45c6acee-d46c-4398-a3e7-f04ae9882f82/Datenschutzinformationen.pdf',
                    s3ref: {
                      bucket: 'epilot-dev-user-content',
                      key: '739224/45c6acee-d46c-4398-a3e7-f04ae9882f82/Datenschutzinformationen.pdf'
                    },
                    versions: [
                      {
                        _manifest: ['9d4fc066-64c9-48af-9245-4e47c5d1e8f2'],
                        _purpose: [],
                        _tags: ['Commodity', 'Datenschutz'],
                        _title: 'Datenschutzinformationen.pdf',
                        access_control: 'public-read',
                        filename: 'Datenschutzinformationen.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-dev-user-content.s3.eu-central-1.amazonaws.com/739224/45c6acee-d46c-4398-a3e7-f04ae9882f82/Datenschutzinformationen.pdf',
                        s3ref: {
                          bucket: 'epilot-dev-user-content',
                          key: '739224/45c6acee-d46c-4398-a3e7-f04ae9882f82/Datenschutzinformationen.pdf'
                        }
                      }
                    ],
                    _schema: 'file',
                    _org: '739224',
                    _owners: [
                      {
                        org_id: '739224',
                        user_id: '10010729'
                      }
                    ],
                    _created_at: '2025-04-04T13:46:31.072Z',
                    _updated_at: '2025-04-04T13:46:32.518Z',
                    _acl: {
                      view: ['org_739224'],
                      edit: ['org_739224'],
                      delete: ['org_739224']
                    },
                    source_url:
                      'https://file.dev.sls.epilot.io/v1/files/public/links/739224-x0AiSSwQ5POcPADAkmWE6/Datenschutzinformationen.pdf?hash=4a5d8445',
                    $relation: {
                      entity_id: '2767d43f-5ecf-437f-81ca-90eb71880a98'
                    }
                  },
                  {
                    _id: '8de8deac-d9e5-4863-936b-697d1a86d029',
                    _manifest: ['9d4fc066-64c9-48af-9245-4e47c5d1e8f2'],
                    _purpose: [],
                    _tags: ['Commodity', 'AGB'],
                    _title: 'AGB.pdf',
                    access_control: 'public-read',
                    filename: 'AGB.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-dev-user-content.s3.eu-central-1.amazonaws.com/739224/e65d7b1f-8db3-4e46-9c8e-443a15ff59d9/AGB.pdf',
                    s3ref: {
                      bucket: 'epilot-dev-user-content',
                      key: '739224/e65d7b1f-8db3-4e46-9c8e-443a15ff59d9/AGB.pdf'
                    },
                    versions: [
                      {
                        _manifest: ['9d4fc066-64c9-48af-9245-4e47c5d1e8f2'],
                        _purpose: [],
                        _tags: ['Commodity', 'AGB'],
                        _title: 'AGB.pdf',
                        access_control: 'public-read',
                        filename: 'AGB.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-dev-user-content.s3.eu-central-1.amazonaws.com/739224/e65d7b1f-8db3-4e46-9c8e-443a15ff59d9/AGB.pdf',
                        s3ref: {
                          bucket: 'epilot-dev-user-content',
                          key: '739224/e65d7b1f-8db3-4e46-9c8e-443a15ff59d9/AGB.pdf'
                        }
                      }
                    ],
                    _schema: 'file',
                    _org: '739224',
                    _owners: [
                      {
                        org_id: '739224',
                        user_id: '10010729'
                      }
                    ],
                    _created_at: '2025-04-04T13:46:33.217Z',
                    _updated_at: '2025-04-04T13:46:33.918Z',
                    _acl: {
                      view: ['org_739224'],
                      edit: ['org_739224'],
                      delete: ['org_739224']
                    },
                    source_url:
                      'https://file.dev.sls.epilot.io/v1/files/public/links/739224-xK-vxqUmKHMYcYM_5Tlui/AGB.pdf?hash=66202eee',
                    $relation: {
                      entity_id: '8de8deac-d9e5-4863-936b-697d1a86d029'
                    }
                  },
                  {
                    _id: '357e3a2e-e3f4-4b52-ab00-73fb2231269c',
                    _manifest: ['9d4fc066-64c9-48af-9245-4e47c5d1e8f2'],
                    _purpose: [],
                    _tags: ['Commodity', 'Widerrufsformular'],
                    _title: 'Muster-Widerrufsformular.pdf',
                    access_control: 'public-read',
                    filename: 'Muster-Widerrufsformular.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-dev-user-content.s3.eu-central-1.amazonaws.com/739224/d9d6c4d2-23d6-4d60-a7da-54933e980a1e/Muster-Widerrufsformular.pdf',
                    s3ref: {
                      bucket: 'epilot-dev-user-content',
                      key: '739224/d9d6c4d2-23d6-4d60-a7da-54933e980a1e/Muster-Widerrufsformular.pdf'
                    },
                    versions: [
                      {
                        _manifest: ['9d4fc066-64c9-48af-9245-4e47c5d1e8f2'],
                        _purpose: [],
                        _tags: ['Commodity', 'Widerrufsformular'],
                        _title: 'Muster-Widerrufsformular.pdf',
                        access_control: 'public-read',
                        filename: 'Muster-Widerrufsformular.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-dev-user-content.s3.eu-central-1.amazonaws.com/739224/d9d6c4d2-23d6-4d60-a7da-54933e980a1e/Muster-Widerrufsformular.pdf',
                        s3ref: {
                          bucket: 'epilot-dev-user-content',
                          key: '739224/d9d6c4d2-23d6-4d60-a7da-54933e980a1e/Muster-Widerrufsformular.pdf'
                        }
                      }
                    ],
                    _schema: 'file',
                    _org: '739224',
                    _owners: [
                      {
                        org_id: '739224',
                        user_id: '10010729'
                      }
                    ],
                    _created_at: '2025-04-04T13:46:33.386Z',
                    _updated_at: '2025-04-04T13:46:34.661Z',
                    _acl: {
                      view: ['org_739224'],
                      edit: ['org_739224'],
                      delete: ['org_739224']
                    },
                    source_url:
                      'https://file.dev.sls.epilot.io/v1/files/public/links/739224-D-p7kbOSMbPT-jFHmeYlK/Muster-Widerrufsformular.pdf?hash=a55d3f6a',
                    $relation: {
                      entity_id: '357e3a2e-e3f4-4b52-ab00-73fb2231269c'
                    }
                  },
                  {
                    _id: '844beef4-0938-46a4-8af9-a3fa7881fc90',
                    _manifest: ['9d4fc066-64c9-48af-9245-4e47c5d1e8f2'],
                    _purpose: [],
                    _tags: ['Commodity', 'Preisblatt'],
                    _title: 'Preisblatt.pdf',
                    access_control: 'public-read',
                    filename: 'Preisblatt.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-dev-user-content.s3.eu-central-1.amazonaws.com/739224/c06853e2-ed72-4112-ae5d-26c7d60477c1/Preisblatt.pdf',
                    s3ref: {
                      bucket: 'epilot-dev-user-content',
                      key: '739224/c06853e2-ed72-4112-ae5d-26c7d60477c1/Preisblatt.pdf'
                    },
                    versions: [
                      {
                        _manifest: ['9d4fc066-64c9-48af-9245-4e47c5d1e8f2'],
                        _purpose: [],
                        _tags: ['Commodity', 'Preisblatt'],
                        _title: 'Preisblatt.pdf',
                        access_control: 'public-read',
                        filename: 'Preisblatt.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-dev-user-content.s3.eu-central-1.amazonaws.com/739224/c06853e2-ed72-4112-ae5d-26c7d60477c1/Preisblatt.pdf',
                        s3ref: {
                          bucket: 'epilot-dev-user-content',
                          key: '739224/c06853e2-ed72-4112-ae5d-26c7d60477c1/Preisblatt.pdf'
                        }
                      }
                    ],
                    _schema: 'file',
                    _org: '739224',
                    _owners: [
                      {
                        org_id: '739224',
                        user_id: '10010729'
                      }
                    ],
                    _created_at: '2025-04-04T13:46:33.296Z',
                    _updated_at: '2025-04-04T13:46:33.920Z',
                    _acl: {
                      view: ['org_739224'],
                      edit: ['org_739224'],
                      delete: ['org_739224']
                    },
                    source_url:
                      'https://file.dev.sls.epilot.io/v1/files/public/links/739224-QvQSxTEV7QsGZ591rp9AY/Preisblatt.pdf?hash=a5b5b086',
                    $relation: {
                      entity_id: '844beef4-0938-46a4-8af9-a3fa7881fc90'
                    }
                  }
                ],
                product_images: [
                  {
                    _id: 'd271a66e-4382-4f04-b4c6-0dc6faf18d28',
                    _manifest: ['9d4fc066-64c9-48af-9245-4e47c5d1e8f2'],
                    _purpose: ['d6c77db1-aa76-44b2-b021-6e540a367d91'],
                    _tags: ['Commodity', 'Produkt-Illustration'],
                    _title: 'Strom.png',
                    access_control: 'public-read',
                    filename: 'Strom.png',
                    mime_type: 'image/png',
                    type: 'image',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 83324,
                    readable_size: '81.37 KB',
                    public_url:
                      'https://epilot-dev-user-content.s3.eu-central-1.amazonaws.com/739224/0b9b724e-6f21-4b10-a647-49cdb4f05455/Strom.png',
                    s3ref: {
                      bucket: 'epilot-dev-user-content',
                      key: '739224/0b9b724e-6f21-4b10-a647-49cdb4f05455/Strom.png'
                    },
                    versions: [
                      {
                        _manifest: ['9d4fc066-64c9-48af-9245-4e47c5d1e8f2'],
                        _purpose: ['d6c77db1-aa76-44b2-b021-6e540a367d91'],
                        _tags: ['Commodity', 'Produkt-Illustration'],
                        _title: 'Strom.png',
                        access_control: 'public-read',
                        filename: 'Strom.png',
                        mime_type: 'image/png',
                        type: 'image',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 83324,
                        readable_size: '81.37 KB',
                        public_url:
                          'https://epilot-dev-user-content.s3.eu-central-1.amazonaws.com/739224/0b9b724e-6f21-4b10-a647-49cdb4f05455/Strom.png',
                        s3ref: {
                          bucket: 'epilot-dev-user-content',
                          key: '739224/0b9b724e-6f21-4b10-a647-49cdb4f05455/Strom.png'
                        }
                      }
                    ],
                    _schema: 'file',
                    _org: '739224',
                    _owners: [
                      {
                        org_id: '739224',
                        user_id: '10010729'
                      }
                    ],
                    _created_at: '2025-04-04T13:46:36.117Z',
                    _updated_at: '2025-04-04T13:46:36.807Z',
                    _acl: {
                      view: ['org_739224'],
                      edit: ['org_739224'],
                      delete: ['org_739224']
                    },
                    source_url:
                      'https://file.dev.sls.epilot.io/v1/files/public/links/739224-DhS3Posblzn8iWiLkGVUw/Strom.png?hash=11ebd33a',
                    $relation: {
                      entity_id: 'd271a66e-4382-4f04-b4c6-0dc6faf18d28'
                    }
                  }
                ],
                type: 'product',
                _id: 'edc72ca3-d965-4db1-b6b6-5421b552f808',
                _title: 'Dummy - Strom Commodity 1',
                _messages: {}
              },
              taxes: [
                {
                  tax: {
                    _manifest: [
                      '956e9f44-0d8e-4d50-af85-e528fb130d64',
                      '23af06ca-f23c-4325-969a-a45ae3f96c19'
                    ],
                    _schema: 'tax',
                    active: true,
                    description: '19%',
                    rate: '19',
                    region: 'DE',
                    type: 'VAT',
                    _id: '89a8fa55-b850-474e-9110-ae4a14aec6e2',
                    _org: '739224',
                    _owners: [
                      {
                        org_id: '739224',
                        user_id: '10010729'
                      }
                    ],
                    _created_at: '2025-03-06T07:30:25.408Z',
                    _updated_at: '2025-03-06T07:30:25.408Z',
                    _title: '19%',
                    _acl: {
                      view: ['org_739224'],
                      edit: ['org_739224'],
                      delete: ['org_739224']
                    }
                  },
                  amount: 20112
                }
              ],
              type: 'recurring',
              billing_period: 'monthly',
              tiers_details: [
                {
                  quantity: 1000,
                  unit_amount: 14,
                  unit_amount_decimal: '0.14',
                  unit_amount_net: 14,
                  unit_amount_gross: 17,
                  amount_subtotal: 14000,
                  amount_total: 16660,
                  amount_tax: 2660
                },
                {
                  quantity: 1000,
                  unit_amount: 5,
                  unit_amount_decimal: '0.054',
                  unit_amount_net: 5,
                  unit_amount_gross: 6,
                  amount_subtotal: 5400,
                  amount_total: 6426,
                  amount_tax: 1026
                },
                {
                  quantity: 1000,
                  unit_amount: 5,
                  unit_amount_decimal: '0.053',
                  unit_amount_net: 5,
                  unit_amount_gross: 6,
                  amount_subtotal: 5300,
                  amount_total: 6307,
                  amount_tax: 1007
                },
                {
                  quantity: 16230.769230769232,
                  unit_amount: 5,
                  unit_amount_decimal: '0.05',
                  unit_amount_net: 5,
                  unit_amount_gross: 6,
                  amount_subtotal: 81154,
                  amount_total: 96573,
                  amount_tax: 15419
                }
              ],
              unit_amount_gross: 35,
              unit_amount_net: 30,
              amount_subtotal: 105854,
              amount_total: 125966,
              amount_tax: 20112,
              currency: 'EUR',
              is_tax_inclusive: false,
              unit_amount_net_decimal: '0.297',
              unit_amount_gross_decimal: '0.35343',
              amount_subtotal_decimal: '1058.538461538462',
              amount_total_decimal: '1259.660769230769'
            }
          ],
          _price: {
            _id: '933c64f9-4e39-465a-ae00-768d5e525c97',
            description: '[Graduated] - Consumption II 2',
            internal_description: '[Graduated] - Consumption II 2',
            pricing_model: 'per_unit',
            unit_amount: 0,
            unit_amount_currency: 'EUR',
            unit_amount_decimal: '0.00',
            is_tax_inclusive: true,
            price_display_in_journeys: 'show_price',
            active: true,
            type: 'one_time',
            billing_duration_unit: 'months',
            notice_time_unit: 'months',
            termination_time_unit: 'months',
            renewal_duration_unit: 'months',
            is_composite_price: true,
            price_components: [
              {
                _id: '004a11ee-8fcf-4ba3-b0e0-92d7443ce7a1',
                _manifest: ['ed0984d4-c46d-4ed0-844b-dc06cf1ee2a2'],
                _tags: [],
                active: true,
                billing_duration_unit: 'months',
                description: '[Graduated] - Consumption II 1',
                is_tax_inclusive: false,
                long_description: 'component description',
                notice_time_unit: 'months',
                price_display_in_journeys: 'show_price',
                pricing_model: 'tiered_graduated',
                renewal_duration_unit: 'months',
                tax: {
                  $relation: [
                    {
                      entity_id: '89a8fa55-b850-474e-9110-ae4a14aec6e2'
                    }
                  ]
                },
                termination_time_unit: 'months',
                tiers: [
                  {
                    flat_fee_amount: 0,
                    flat_fee_amount_decimal: '0',
                    unit_amount: 14,
                    unit_amount_decimal: '0.14',
                    up_to: 1000
                  },
                  {
                    flat_fee_amount: 0,
                    flat_fee_amount_decimal: '0',
                    unit_amount: 5,
                    unit_amount_decimal: '0.054',
                    up_to: 2000
                  },
                  {
                    flat_fee_amount: 0,
                    flat_fee_amount_decimal: '0',
                    unit_amount: 5,
                    unit_amount_decimal: '0.053',
                    up_to: 3000
                  },
                  {
                    flat_fee_amount: 0,
                    flat_fee_amount_decimal: '0',
                    unit_amount: 5,
                    unit_amount_decimal: '0.05'
                  }
                ],
                type: 'recurring',
                unit: 'kwh',
                unit_amount: 0,
                unit_amount_currency: 'EUR',
                unit_amount_decimal: '0',
                variable_price: true,
                billing_period: 'monthly',
                internal_description: '[Graduated] - Consumption II',
                _title: '[Graduated] - Consumption II 1'
              },
              {
                _id: 'f45701f2-2f60-4b16-a384-2886b37ccfb1',
                _manifest: ['9d4fc066-64c9-48af-9245-4e47c5d1e8f2'],
                _purpose: ['f15029a6-f189-4530-bf6c-b4bf52b9ce7b'],
                _tags: ['Commodity', 'Wärmestrom'],
                active: true,
                description: 'Arbeitspreis HT',
                is_tax_inclusive: true,
                price_display_in_journeys: 'show_price',
                pricing_model: 'per_unit',
                tax: {
                  $relation: [
                    {
                      entity_id: '936db2a1-3748-45b6-bb9d-04943280ceeb'
                    }
                  ]
                },
                tiers: [],
                type: 'recurring',
                unit: 'kwh',
                unit_amount: 1500,
                unit_amount_currency: 'EUR',
                unit_amount_decimal: '15',
                variable_price: true,
                billing_duration_amount: null,
                billing_duration_unit: null,
                billing_period: 'monthly',
                internal_description: 'Arbeitspreis HT',
                notice_time_amount: null,
                notice_time_unit: null,
                price_components: null,
                renewal_duration_amount: null,
                renewal_duration_unit: null,
                termination_time_amount: null,
                termination_time_unit: null,
                _title: 'Arbeitspreis HT',
                unit_amount2: 1500,
                unit_amount2_decimal: '15.00',
                unit_amount2_currency: 'EUR'
              }
            ],
            _tags: ['composite'],
            billing_period: 'weekly',
            _title: '[Graduated] - Consumption II 2'
          },
          _product: {
            _manifest: ['9d4fc066-64c9-48af-9245-4e47c5d1e8f2'],
            _purpose: ['d6c77db1-aa76-44b2-b021-6e540a367d91'],
            _tags: ['Commodity', 'Strom'],
            active: true,
            categories: [],
            description: 'Außerhalb der Grundversorgung',
            feature: [
              {
                _id: 'Y_QjVZ9MHTf8KCp4RFBeW',
                _tags: [],
                feature: '100% Ökostrom',
                value: ''
              },
              {
                _id: 'N7NMWrgGgYqmIHs-Jt6Hq',
                _tags: [],
                feature: 'Erstlaufzeit bis 31.12.2025',
                value: ''
              },
              {
                _id: 'SbRtgtY6flxvlR1M-LaHi',
                _tags: [],
                feature: 'Kündigungsfrist 1 Monat',
                value: ''
              },
              {
                _id: 'v07rw_RfinlcUOfQD0h9S',
                _tags: [],
                feature:
                  '100 % Preisgarantie auf den Energiepreis (ausgenommen Netzentgelte, Umlagen/Steuern)',
                value: ''
              }
            ],
            internal_name: 'Dummy - Strom Commodity',
            name: 'Dummy - Strom Commodity 1',
            price_options: [
              {
                _id: '1793cd14-258e-4d6f-b13e-82e093dfd102',
                _manifest: ['9d4fc066-64c9-48af-9245-4e47c5d1e8f2'],
                _purpose: ['d6c77db1-aa76-44b2-b021-6e540a367d91'],
                _schema: 'price',
                _tags: ['Commodity', 'Strom'],
                active: true,
                description: 'Dummy - Commodity Strom',
                is_composite_price: true,
                is_tax_inclusive: null,
                price_components: [],
                price_display_in_journeys: 'show_price',
                pricing_model: null,
                tiers: [],
                type: null,
                unit_amount: 0,
                unit_amount_currency: 'EUR',
                unit_amount_decimal: '0.00',
                variable_price: null,
                billing_duration_amount: null,
                billing_duration_unit: null,
                billing_period: null,
                internal_description: 'Dummy - Commodity Strom',
                notice_time_amount: null,
                notice_time_unit: null,
                renewal_duration_amount: null,
                renewal_duration_unit: null,
                termination_time_amount: null,
                termination_time_unit: null,
                unit: null,
                _org: '739224',
                _owners: [
                  {
                    org_id: '739224',
                    user_id: '10010729'
                  }
                ],
                _created_at: '2025-04-04T13:46:39.551Z',
                _updated_at: '2025-04-04T13:46:39.551Z',
                _title: 'Dummy - Commodity Strom',
                _acl: {
                  view: ['org_739224'],
                  edit: ['org_739224'],
                  delete: ['org_739224']
                },
                $relation: {
                  entity_id: '1793cd14-258e-4d6f-b13e-82e093dfd102',
                  _schema: 'price'
                }
              },
              {
                _id: 'b239bbfd-2bf7-43b3-84c0-ba389d059fb3',
                _manifest: ['9d4fc066-64c9-48af-9245-4e47c5d1e8f2'],
                _purpose: ['d6c77db1-aa76-44b2-b021-6e540a367d91'],
                _schema: 'price',
                _tags: ['Commodity', 'Strom'],
                active: true,
                billing_duration_unit: 'months',
                description: 'Dummy - Commodity Strom dynamisch',
                is_composite_price: true,
                is_tax_inclusive: true,
                notice_time_unit: 'months',
                price_components: [],
                price_display_in_journeys: 'show_price',
                pricing_model: 'per_unit',
                renewal_duration_unit: 'months',
                termination_time_unit: 'months',
                tiers: [],
                type: 'one_time',
                unit_amount: 0,
                unit_amount_currency: 'EUR',
                unit_amount_decimal: '0.00',
                variable_price: false,
                billing_period: 'weekly',
                internal_description: 'Dummy - Commodity Strom dynamisch',
                _org: '739224',
                _owners: [
                  {
                    org_id: '739224',
                    user_id: '10010729'
                  }
                ],
                _created_at: '2025-04-04T13:46:40.812Z',
                _updated_at: '2025-04-04T13:46:40.812Z',
                _title: 'Dummy - Commodity Strom dynamisch',
                _acl: {
                  view: ['org_739224'],
                  edit: ['org_739224'],
                  delete: ['org_739224']
                },
                $relation: {
                  entity_id: 'b239bbfd-2bf7-43b3-84c0-ba389d059fb3',
                  _schema: 'price'
                }
              },
              {
                _id: '004a11ee-8fcf-4ba3-b0e0-92d7443ce7a1',
                _manifest: ['ed0984d4-c46d-4ed0-844b-dc06cf1ee2a2'],
                _schema: 'price',
                _tags: [],
                active: true,
                billing_duration_unit: 'months',
                description: '[Graduated] - Consumption II 1',
                is_tax_inclusive: false,
                long_description: 'component description',
                notice_time_unit: 'months',
                price_display_in_journeys: 'show_price',
                pricing_model: 'tiered_graduated',
                renewal_duration_unit: 'months',
                tax: [],
                termination_time_unit: 'months',
                tiers: [
                  {
                    flat_fee_amount: 0,
                    flat_fee_amount_decimal: '0',
                    unit_amount: 14,
                    unit_amount_decimal: '0.14',
                    up_to: 1000
                  },
                  {
                    flat_fee_amount: 0,
                    flat_fee_amount_decimal: '0',
                    unit_amount: 5,
                    unit_amount_decimal: '0.054',
                    up_to: 2000
                  },
                  {
                    flat_fee_amount: 0,
                    flat_fee_amount_decimal: '0',
                    unit_amount: 5,
                    unit_amount_decimal: '0.053',
                    up_to: 3000
                  },
                  {
                    flat_fee_amount: 0,
                    flat_fee_amount_decimal: '0',
                    unit_amount: 5,
                    unit_amount_decimal: '0.05'
                  }
                ],
                type: 'recurring',
                unit: 'kwh',
                unit_amount: 0,
                unit_amount_currency: 'EUR',
                unit_amount_decimal: '0',
                variable_price: true,
                _acl_sync: '2025-03-11T13:48:28.862Z',
                billing_period: 'monthly',
                internal_description: '[Graduated] - Consumption II',
                _org: '739224',
                _owners: [
                  {
                    org_id: '739224',
                    user_id: '11000933'
                  }
                ],
                _created_at: '2024-09-26T13:05:59.823Z',
                _updated_at: '2025-04-08T06:37:49.442Z',
                _title: '[Graduated] - Consumption II 1',
                _acl: {
                  view: ['org_739224', 'org_911675'],
                  edit: ['org_739224'],
                  delete: ['org_739224']
                },
                $relation: {
                  entity_id: '004a11ee-8fcf-4ba3-b0e0-92d7443ce7a1',
                  _schema: 'price',
                  _tags: []
                }
              },
              {
                _id: '933c64f9-4e39-465a-ae00-768d5e525c97',
                description: '[Graduated] - Consumption II 2',
                internal_description: '[Graduated] - Consumption II 2',
                pricing_model: 'per_unit',
                unit_amount: 0,
                unit_amount_currency: 'EUR',
                unit_amount_decimal: '0.00',
                is_tax_inclusive: true,
                price_display_in_journeys: 'show_price',
                active: true,
                type: 'one_time',
                billing_duration_unit: 'months',
                notice_time_unit: 'months',
                termination_time_unit: 'months',
                renewal_duration_unit: 'months',
                is_composite_price: true,
                price_components: [],
                _tags: ['composite'],
                _schema: 'price',
                _org: '739224',
                _owners: [
                  {
                    org_id: '739224',
                    user_id: '11001058'
                  }
                ],
                _created_at: '2025-04-08T06:45:31.550Z',
                _updated_at: '2025-04-08T06:45:31.550Z',
                billing_period: 'weekly',
                _title: '[Graduated] - Consumption II 2',
                _acl: {
                  view: ['org_739224'],
                  edit: ['org_739224'],
                  delete: ['org_739224']
                },
                $relation: {
                  entity_id: '933c64f9-4e39-465a-ae00-768d5e525c97',
                  _tags: []
                }
              }
            ],
            product_downloads: [
              {
                _id: '2767d43f-5ecf-437f-81ca-90eb71880a98',
                _manifest: ['9d4fc066-64c9-48af-9245-4e47c5d1e8f2'],
                _purpose: [],
                _tags: ['Commodity', 'Datenschutz'],
                _title: 'Datenschutzinformationen.pdf',
                access_control: 'public-read',
                filename: 'Datenschutzinformationen.pdf',
                mime_type: 'application/pdf',
                type: 'document',
                category: 'unknown',
                file_entity_id: '',
                size_bytes: 11451,
                readable_size: '11.18 KB',
                public_url:
                  'https://epilot-dev-user-content.s3.eu-central-1.amazonaws.com/739224/45c6acee-d46c-4398-a3e7-f04ae9882f82/Datenschutzinformationen.pdf',
                s3ref: {
                  bucket: 'epilot-dev-user-content',
                  key: '739224/45c6acee-d46c-4398-a3e7-f04ae9882f82/Datenschutzinformationen.pdf'
                },
                versions: [
                  {
                    _manifest: ['9d4fc066-64c9-48af-9245-4e47c5d1e8f2'],
                    _purpose: [],
                    _tags: ['Commodity', 'Datenschutz'],
                    _title: 'Datenschutzinformationen.pdf',
                    access_control: 'public-read',
                    filename: 'Datenschutzinformationen.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-dev-user-content.s3.eu-central-1.amazonaws.com/739224/45c6acee-d46c-4398-a3e7-f04ae9882f82/Datenschutzinformationen.pdf',
                    s3ref: {
                      bucket: 'epilot-dev-user-content',
                      key: '739224/45c6acee-d46c-4398-a3e7-f04ae9882f82/Datenschutzinformationen.pdf'
                    }
                  }
                ],
                _schema: 'file',
                _org: '739224',
                _owners: [
                  {
                    org_id: '739224',
                    user_id: '10010729'
                  }
                ],
                _created_at: '2025-04-04T13:46:31.072Z',
                _updated_at: '2025-04-04T13:46:32.518Z',
                _acl: {
                  view: ['org_739224'],
                  edit: ['org_739224'],
                  delete: ['org_739224']
                },
                source_url:
                  'https://file.dev.sls.epilot.io/v1/files/public/links/739224-x0AiSSwQ5POcPADAkmWE6/Datenschutzinformationen.pdf?hash=4a5d8445',
                $relation: {
                  entity_id: '2767d43f-5ecf-437f-81ca-90eb71880a98'
                }
              },
              {
                _id: '8de8deac-d9e5-4863-936b-697d1a86d029',
                _manifest: ['9d4fc066-64c9-48af-9245-4e47c5d1e8f2'],
                _purpose: [],
                _tags: ['Commodity', 'AGB'],
                _title: 'AGB.pdf',
                access_control: 'public-read',
                filename: 'AGB.pdf',
                mime_type: 'application/pdf',
                type: 'document',
                category: 'unknown',
                file_entity_id: '',
                size_bytes: 11451,
                readable_size: '11.18 KB',
                public_url:
                  'https://epilot-dev-user-content.s3.eu-central-1.amazonaws.com/739224/e65d7b1f-8db3-4e46-9c8e-443a15ff59d9/AGB.pdf',
                s3ref: {
                  bucket: 'epilot-dev-user-content',
                  key: '739224/e65d7b1f-8db3-4e46-9c8e-443a15ff59d9/AGB.pdf'
                },
                versions: [
                  {
                    _manifest: ['9d4fc066-64c9-48af-9245-4e47c5d1e8f2'],
                    _purpose: [],
                    _tags: ['Commodity', 'AGB'],
                    _title: 'AGB.pdf',
                    access_control: 'public-read',
                    filename: 'AGB.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-dev-user-content.s3.eu-central-1.amazonaws.com/739224/e65d7b1f-8db3-4e46-9c8e-443a15ff59d9/AGB.pdf',
                    s3ref: {
                      bucket: 'epilot-dev-user-content',
                      key: '739224/e65d7b1f-8db3-4e46-9c8e-443a15ff59d9/AGB.pdf'
                    }
                  }
                ],
                _schema: 'file',
                _org: '739224',
                _owners: [
                  {
                    org_id: '739224',
                    user_id: '10010729'
                  }
                ],
                _created_at: '2025-04-04T13:46:33.217Z',
                _updated_at: '2025-04-04T13:46:33.918Z',
                _acl: {
                  view: ['org_739224'],
                  edit: ['org_739224'],
                  delete: ['org_739224']
                },
                source_url:
                  'https://file.dev.sls.epilot.io/v1/files/public/links/739224-xK-vxqUmKHMYcYM_5Tlui/AGB.pdf?hash=66202eee',
                $relation: {
                  entity_id: '8de8deac-d9e5-4863-936b-697d1a86d029'
                }
              },
              {
                _id: '357e3a2e-e3f4-4b52-ab00-73fb2231269c',
                _manifest: ['9d4fc066-64c9-48af-9245-4e47c5d1e8f2'],
                _purpose: [],
                _tags: ['Commodity', 'Widerrufsformular'],
                _title: 'Muster-Widerrufsformular.pdf',
                access_control: 'public-read',
                filename: 'Muster-Widerrufsformular.pdf',
                mime_type: 'application/pdf',
                type: 'document',
                category: 'unknown',
                file_entity_id: '',
                size_bytes: 11451,
                readable_size: '11.18 KB',
                public_url:
                  'https://epilot-dev-user-content.s3.eu-central-1.amazonaws.com/739224/d9d6c4d2-23d6-4d60-a7da-54933e980a1e/Muster-Widerrufsformular.pdf',
                s3ref: {
                  bucket: 'epilot-dev-user-content',
                  key: '739224/d9d6c4d2-23d6-4d60-a7da-54933e980a1e/Muster-Widerrufsformular.pdf'
                },
                versions: [
                  {
                    _manifest: ['9d4fc066-64c9-48af-9245-4e47c5d1e8f2'],
                    _purpose: [],
                    _tags: ['Commodity', 'Widerrufsformular'],
                    _title: 'Muster-Widerrufsformular.pdf',
                    access_control: 'public-read',
                    filename: 'Muster-Widerrufsformular.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-dev-user-content.s3.eu-central-1.amazonaws.com/739224/d9d6c4d2-23d6-4d60-a7da-54933e980a1e/Muster-Widerrufsformular.pdf',
                    s3ref: {
                      bucket: 'epilot-dev-user-content',
                      key: '739224/d9d6c4d2-23d6-4d60-a7da-54933e980a1e/Muster-Widerrufsformular.pdf'
                    }
                  }
                ],
                _schema: 'file',
                _org: '739224',
                _owners: [
                  {
                    org_id: '739224',
                    user_id: '10010729'
                  }
                ],
                _created_at: '2025-04-04T13:46:33.386Z',
                _updated_at: '2025-04-04T13:46:34.661Z',
                _acl: {
                  view: ['org_739224'],
                  edit: ['org_739224'],
                  delete: ['org_739224']
                },
                source_url:
                  'https://file.dev.sls.epilot.io/v1/files/public/links/739224-D-p7kbOSMbPT-jFHmeYlK/Muster-Widerrufsformular.pdf?hash=a55d3f6a',
                $relation: {
                  entity_id: '357e3a2e-e3f4-4b52-ab00-73fb2231269c'
                }
              },
              {
                _id: '844beef4-0938-46a4-8af9-a3fa7881fc90',
                _manifest: ['9d4fc066-64c9-48af-9245-4e47c5d1e8f2'],
                _purpose: [],
                _tags: ['Commodity', 'Preisblatt'],
                _title: 'Preisblatt.pdf',
                access_control: 'public-read',
                filename: 'Preisblatt.pdf',
                mime_type: 'application/pdf',
                type: 'document',
                category: 'unknown',
                file_entity_id: '',
                size_bytes: 11451,
                readable_size: '11.18 KB',
                public_url:
                  'https://epilot-dev-user-content.s3.eu-central-1.amazonaws.com/739224/c06853e2-ed72-4112-ae5d-26c7d60477c1/Preisblatt.pdf',
                s3ref: {
                  bucket: 'epilot-dev-user-content',
                  key: '739224/c06853e2-ed72-4112-ae5d-26c7d60477c1/Preisblatt.pdf'
                },
                versions: [
                  {
                    _manifest: ['9d4fc066-64c9-48af-9245-4e47c5d1e8f2'],
                    _purpose: [],
                    _tags: ['Commodity', 'Preisblatt'],
                    _title: 'Preisblatt.pdf',
                    access_control: 'public-read',
                    filename: 'Preisblatt.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-dev-user-content.s3.eu-central-1.amazonaws.com/739224/c06853e2-ed72-4112-ae5d-26c7d60477c1/Preisblatt.pdf',
                    s3ref: {
                      bucket: 'epilot-dev-user-content',
                      key: '739224/c06853e2-ed72-4112-ae5d-26c7d60477c1/Preisblatt.pdf'
                    }
                  }
                ],
                _schema: 'file',
                _org: '739224',
                _owners: [
                  {
                    org_id: '739224',
                    user_id: '10010729'
                  }
                ],
                _created_at: '2025-04-04T13:46:33.296Z',
                _updated_at: '2025-04-04T13:46:33.920Z',
                _acl: {
                  view: ['org_739224'],
                  edit: ['org_739224'],
                  delete: ['org_739224']
                },
                source_url:
                  'https://file.dev.sls.epilot.io/v1/files/public/links/739224-QvQSxTEV7QsGZ591rp9AY/Preisblatt.pdf?hash=a5b5b086',
                $relation: {
                  entity_id: '844beef4-0938-46a4-8af9-a3fa7881fc90'
                }
              }
            ],
            product_images: [
              {
                _id: 'd271a66e-4382-4f04-b4c6-0dc6faf18d28',
                _manifest: ['9d4fc066-64c9-48af-9245-4e47c5d1e8f2'],
                _purpose: ['d6c77db1-aa76-44b2-b021-6e540a367d91'],
                _tags: ['Commodity', 'Produkt-Illustration'],
                _title: 'Strom.png',
                access_control: 'public-read',
                filename: 'Strom.png',
                mime_type: 'image/png',
                type: 'image',
                category: 'unknown',
                file_entity_id: '',
                size_bytes: 83324,
                readable_size: '81.37 KB',
                public_url:
                  'https://epilot-dev-user-content.s3.eu-central-1.amazonaws.com/739224/0b9b724e-6f21-4b10-a647-49cdb4f05455/Strom.png',
                s3ref: {
                  bucket: 'epilot-dev-user-content',
                  key: '739224/0b9b724e-6f21-4b10-a647-49cdb4f05455/Strom.png'
                },
                versions: [
                  {
                    _manifest: ['9d4fc066-64c9-48af-9245-4e47c5d1e8f2'],
                    _purpose: ['d6c77db1-aa76-44b2-b021-6e540a367d91'],
                    _tags: ['Commodity', 'Produkt-Illustration'],
                    _title: 'Strom.png',
                    access_control: 'public-read',
                    filename: 'Strom.png',
                    mime_type: 'image/png',
                    type: 'image',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 83324,
                    readable_size: '81.37 KB',
                    public_url:
                      'https://epilot-dev-user-content.s3.eu-central-1.amazonaws.com/739224/0b9b724e-6f21-4b10-a647-49cdb4f05455/Strom.png',
                    s3ref: {
                      bucket: 'epilot-dev-user-content',
                      key: '739224/0b9b724e-6f21-4b10-a647-49cdb4f05455/Strom.png'
                    }
                  }
                ],
                _schema: 'file',
                _org: '739224',
                _owners: [
                  {
                    org_id: '739224',
                    user_id: '10010729'
                  }
                ],
                _created_at: '2025-04-04T13:46:36.117Z',
                _updated_at: '2025-04-04T13:46:36.807Z',
                _acl: {
                  view: ['org_739224'],
                  edit: ['org_739224'],
                  delete: ['org_739224']
                },
                source_url:
                  'https://file.dev.sls.epilot.io/v1/files/public/links/739224-DhS3Posblzn8iWiLkGVUw/Strom.png?hash=11ebd33a',
                $relation: {
                  entity_id: 'd271a66e-4382-4f04-b4c6-0dc6faf18d28'
                }
              }
            ],
            type: 'product',
            _id: 'edc72ca3-d965-4db1-b6b6-5421b552f808',
            _title: 'Dummy - Strom Commodity 1',
            _messages: {}
          },
          price_mappings: [
            {
              price_id: '004a11ee-8fcf-4ba3-b0e0-92d7443ce7a1',
              value: 1000000,
              frequency_unit: 'yearly'
            },
            {
              price_id: 'f45701f2-2f60-4b16-a384-2886b37ccfb1',
              value: 0
            }
          ],
          currency: 'EUR',
          amount_subtotal: 105854,
          amount_total: 125966,
          total_details: {
            amount_tax: 20112,
            breakdown: {
              taxes: [
                {
                  tax: {
                    _id: '89a8fa55-b850-474e-9110-ae4a14aec6e2',
                    type: 'VAT',
                    rate: '19'
                  },
                  amount: 20112
                }
              ],
              recurrences: [
                {
                  type: 'recurring',
                  billing_period: 'monthly',
                  unit_amount_gross: 35,
                  unit_amount_net: 30,
                  amount_subtotal: 105854,
                  amount_total: 125966,
                  amount_subtotal_decimal: '1058.538461538462',
                  amount_total_decimal: '1259.660769230769',
                  amount_tax: 20112
                }
              ],
              recurrencesByTax: [
                {
                  type: 'recurring',
                  billing_period: 'weekly',
                  amount_total: 125966,
                  amount_subtotal: 105854,
                  amount_tax: 20112,
                  tax: {
                    tax: {
                      _id: '89a8fa55-b850-474e-9110-ae4a14aec6e2',
                      type: 'VAT',
                      rate: '19'
                    },
                    amount: 20112
                  }
                }
              ],
              cashbacks: []
            }
          },
          amount_tax: 20112,
          amount_subtotal_decimal: '1058.538461538462',
          amount_total_decimal: '1259.660769230769'
        }
      ],
      prices: {
        $relation: [
          {
            entity_id: '933c64f9-4e39-465a-ae00-768d5e525c97',
            _schema: 'price',
            _tags: []
          }
        ]
      },
      products: {
        $relation: [
          {
            entity_id: 'edc72ca3-d965-4db1-b6b6-5421b552f808',
            _schema: 'product',
            _tags: []
          }
        ]
      },
      amount_subtotal: 105854,
      amount_total: 125966,
      amount_tax: 20112,
      total_details: {
        amount_tax: 20112,
        breakdown: {
          taxes: [
            {
              tax: {
                _id: '89a8fa55-b850-474e-9110-ae4a14aec6e2',
                type: 'VAT',
                rate: '19'
              },
              amount: 20112
            }
          ],
          recurrences: [
            {
              type: 'recurring',
              billing_period: 'monthly',
              unit_amount_gross: 35,
              unit_amount_net: 30,
              amount_subtotal: 105854,
              amount_total: 125966,
              amount_subtotal_decimal: '1058.538461538462',
              amount_total_decimal: '1259.660769230769',
              amount_tax: 20112
            }
          ],
          recurrencesByTax: [
            {
              type: 'recurring',
              billing_period: 'weekly',
              amount_total: 125966,
              amount_subtotal: 105854,
              amount_tax: 20112,
              tax: {
                tax: {
                  _id: '89a8fa55-b850-474e-9110-ae4a14aec6e2',
                  type: 'VAT',
                  rate: '19'
                },
                amount: 20112
              }
            }
          ],
          cashbacks: []
        }
      },
      _schema: 'order',
      _id: '8a2fcd66-64c7-4155-8655-a96b67d9f38f',
      _org: '739224',
      _created_at: '2025-03-19T16:12:18.015Z',
      _updated_at: '2025-06-12T06:28:04.733Z',
      order_number: 'OR-5147',
      _title: 'OR-5147',
      billing_contact: {
        $relation: [
          {
            entity_id: '1c22c787-ab7d-4069-a52b-987e7129297a',
            _tags: ['customer'],
            _schema: 'contact'
          },
          {
            entity_id: '1f6e1aff-75d1-4920-baf5-1588a9b9e220',
            _schema: 'contact',
            _tags: []
          },
          {
            entity_id: '4eced95d-9b82-4de5-846b-0fa8450b5292',
            _tags: []
          }
        ]
      },
      customer: {
        $relation: [
          {
            entity_id: '8ac04976-0799-44bf-8d75-6f2c26f3323c',
            _tags: []
          }
        ]
      },
      redeemed_promos: [],
      mapped_entities: {
        $relation: [
          {
            entity_id: 'a96f3a65-0ce1-4fad-8264-0f4dad618c5e',
            _tags: []
          }
        ]
      },
      workflow: [],
      journey_actions: []
    },
    {
      source: {
        title: 'manual',
        href: null
      },
      source_type: 'manual',
      customer: {
        $relation: []
      },
      billing_contact: {
        $relation: [
          {
            entity_id: '1f6e1aff-75d1-4920-baf5-1588a9b9e220',
            _tags: []
          }
        ]
      },
      _schema: 'order',
      status: '',
      _id: '7c84255d-e479-4624-b589-8ed4d327ed30',
      _org: '739224',
      _created_at: '2025-03-17T07:49:06.254Z',
      _updated_at: '2025-04-02T03:44:50.316Z',
      order_number: 'OR-5136',
      _title: 'OR-5136',
      dates: [
        {
          _id: '3cosTRR8A1R6Fngq3C48T',
          _tags: [],
          value: '2025-03-17T09:35:00.000Z'
        }
      ],
      workflow: [
        {
          version: 2,
          closedBy: '739224_11001058',
          lastUpdateTime: '2025-03-24T09:44:46.174Z',
          trigger: 'MANUAL',
          assignedTo: [],
          creationTime: '2025-03-17T09:32:18.706Z',
          status: 'DONE',
          wfExecId: '0imavbu72hf',
          updateEntityAttributes: [],
          selectedClosingReasons: [],
          completedTime: '2025-03-24T09:44:46.174Z',
          enableECPWorkflow: true,
          name: "Testing Workflow (Gokul) Don't modify",
          nextOpenStep: {
            entityRefId: '0tep3ieqxqj',
            id: '0tep3ieqxqj'
          },
          taxonomies: [],
          flow: [
            {
              startedTime: '2025-03-17T09:32:18.706Z',
              requirements: [],
              created: '2025-03-17T09:32:18.706Z',
              completedTime: '2025-03-17T12:44:46.336Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              type: 'STEP',
              entityRefId: 'tqio3guh628',
              assignedTo: [
                '11001058',
                'ecp_e4393b88-eec0-452a-b204-bbdac04f5f32'
              ],
              enabled: true,
              lastUpdated: '2025-03-17T12:44:46.336Z',
              ecp: {
                description:
                  'Test description which is not too long but not too short',
                enabled: true,
                label: 'Test for ECP'
              },
              userIds: [],
              name: 'Step 1',
              id: 'tqio3guh628',
              definitionId: 'om948Uar',
              status: 'COMPLETED',
              manuallyCreated: false
            },
            {
              completedTime: '2025-03-24T09:44:45.726Z',
              name: 'Gas journey',
              id: 'gwt1wad4r4i',
              type: 'SECTION',
              steps: [
                {
                  startedTime: '2025-03-17T12:44:46.336Z',
                  requirements: [],
                  journey: {
                    name: 'Create New Journey',
                    journeyId: '8033d450-fdab-11ef-842c-d9c470bb2da1',
                    id: 'eb76b09e-f7f9-4640-879c-0c5a6564e36d'
                  },
                  created: '2025-03-17T09:32:18.706Z',
                  completedTime: '2025-03-24T09:44:43.580Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    enabled: false
                  },
                  sectionId: 'gwt1wad4r4i',
                  type: 'STEP',
                  entityRefId: 'khmr3njoma8',
                  assignedTo: [
                    '11001058',
                    'ecp_e4393b88-eec0-452a-b204-bbdac04f5f32'
                  ],
                  enabled: true,
                  lastUpdated: '2025-03-24T09:44:43.580Z',
                  installer: {
                    description: 'With this journey user can change anything!',
                    enabled: true,
                    label: 'Change request via journey'
                  },
                  ecp: {
                    description: 'With this journey user can change anything!',
                    enabled: true,
                    label: 'Change request via journey'
                  },
                  userIds: [],
                  name: 'Step 2',
                  id: 'khmr3njoma8',
                  definitionId: 'RZOEXAYX',
                  status: 'COMPLETED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RZOEXAYX'
                    }
                  ],
                  startedTime: '2025-03-24T09:44:43.580Z',
                  created: '2025-03-17T09:32:18.706Z',
                  completedTime: '2025-03-24T09:44:45.726Z',
                  dueDate: '',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  sectionId: 'gwt1wad4r4i',
                  type: 'STEP',
                  entityRefId: '0tep3ieqxqj',
                  assignedTo: [
                    '11001058',
                    'ecp_e4393b88-eec0-452a-b204-bbdac04f5f32'
                  ],
                  enabled: true,
                  lastUpdated: '2025-03-24T09:44:45.726Z',
                  ecp: {
                    description:
                      'Lorem ipsum is a dummy or placeholder text commonly used in graphic design, publishing, and web development to fill empty spaces.',
                    enabled: true,
                    label: 'Test 3'
                  },
                  dynamicDueDate: {},
                  userIds: [],
                  name: 'Task 2 is required',
                  id: '0tep3ieqxqj',
                  definitionId: 'FzwUj6vW',
                  status: 'COMPLETED',
                  manuallyCreated: false
                }
              ],
              assignedTo: [],
              enabled: true,
              definitionId: 'm9ZmJ_4Q',
              status: 'COMPLETED'
            }
          ],
          closingReasonDescription: '',
          configuredClosingReasonSnapshot: [],
          contexts: [
            {
              schema: 'order',
              title: 'OR-5136',
              id: '7c84255d-e479-4624-b589-8ed4d327ed30'
            }
          ],
          orgId: '739224',
          definitionId: 'wf_9ayWRDT',
          lastModifiedBy: '739224_11001058',
          id: '0imavbu72hf'
        },
        {
          version: 2,
          lastUpdateTime: '2025-03-17T09:32:34.682Z',
          trigger: 'MANUAL',
          assignedTo: [],
          creationTime: '2025-03-17T09:32:30.089Z',
          status: 'STARTED',
          wfExecId: 'ic6cb1w41ul',
          updateEntityAttributes: [],
          selectedClosingReasons: [],
          enableECPWorkflow: true,
          name: 'Photovoltaik-Anlage B2C',
          nextOpenStep: {
            entityRefId: '4bs4n256xfa',
            id: '4bs4n256xfa'
          },
          taxonomies: [],
          flow: [
            {
              completedTime: '2025-03-17T09:32:34.666Z',
              name: 'Prüfungsphase',
              id: 'qeiq0c32bj1',
              type: 'SECTION',
              steps: [
                {
                  requirements: [],
                  startedTime: '2025-03-17T09:32:30.089Z',
                  created: '2025-03-17T09:32:30.089Z',
                  completedTime: '2025-03-17T09:32:34.664Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  sectionId: 'qeiq0c32bj1',
                  type: 'STEP',
                  entityRefId: '413izo79qhq',
                  assignedTo: ['11001058'],
                  lastUpdated: '2025-03-17T09:32:34.665Z',
                  ecp: {
                    description:
                      'Wir haben Ihre Anfrage erhalten und prüfen sie gerade.',
                    enabled: true,
                    label: 'Prüfungsphase'
                  },
                  userIds: [],
                  name: 'Prüfung der Daten auf Richtigkeit und Plausibilität',
                  id: '413izo79qhq',
                  definitionId: 'zzBis4GA',
                  status: 'COMPLETED',
                  manuallyCreated: false,
                  enabled: true
                }
              ],
              assignedTo: [],
              definitionId: '7tPWZ0un',
              status: 'COMPLETED',
              enabled: true
            },
            {
              name: 'Qualifizierungsphase / Vor-Ort-Termin',
              id: 'ahqdvkw5ff5',
              type: 'SECTION',
              steps: [
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    }
                  ],
                  startedTime: '2025-03-17T09:32:34.664Z',
                  created: '2025-03-17T09:32:30.089Z',
                  executionType: 'AUTOMATION',
                  assignedToInProgress: '-',
                  sectionId: 'ahqdvkw5ff5',
                  type: 'STEP',
                  entityRefId: '4bs4n256xfa',
                  automationConfig: {
                    flowId: '04bac352-a8c3-41f5-8932-ea345a903ac5'
                  },
                  assignedTo: [],
                  enabled: true,
                  lastUpdated: '2025-03-17T09:32:30.089Z',
                  userIds: [],
                  name: 'Kontaktaufnahme mit Interessent:in für Terminvereinbarung Vor-Ort-Beratung nicht erfolgreich - Automatisierung ausführen, um Interessent:in zwecks Rückruf zu kontaktieren. Wenn Kontaktaufnahme erfolgreich, Schritt überspringen.',
                  id: '4bs4n256xfa',
                  definitionId: 'yN5f0rIA',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    }
                  ],
                  startedTime: '2025-03-17T09:32:30.089Z',
                  created: '2025-03-17T09:32:30.089Z',
                  executionType: 'AUTOMATION',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'Nach dem dritten Kontaktversuch: Frist auf +30 Tage setzen. Wenn innerhalb dieser Frist keine Rückmeldung durch Interessent:in Automatisierung ausführen, um Interessent:in über Prozessabbruch zu informieren - Prozess abbrechen und Abbruchgrund nennen. Wenn innerhalb der Frist eine Kontaktaufnahme erfolgt ist, Schritt überspringen.',
                    enabled: true
                  },
                  sectionId: 'ahqdvkw5ff5',
                  type: 'STEP',
                  entityRefId: 'hrgljln18t3',
                  automationConfig: {
                    flowId: 'fa1a0cbb-7e13-4dba-8900-fe58bee76995'
                  },
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-03-17T09:32:30.089Z',
                  dynamicDueDate: {
                    stepId: 'yN5f0rIA',
                    timePeriod: 'days',
                    numberOfUnits: 1,
                    actionTypeCondition: 'STEP_CLOSED'
                  },
                  userIds: [],
                  name: 'Weitere Kontaktaufnahme. Falls Interessent:in wieder nicht erreicht, Aufgabe offen lassen, Frist auf +1 Tag setzen und Automatisierung aus vorherigem Schritt erneut ausführen. Wenn Kontaktaufnahme erfolgreich, Schritt überspringen.',
                  id: 'hrgljln18t3',
                  definitionId: 'EeCC5puB',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    }
                  ],
                  startedTime: '2025-03-17T09:32:30.089Z',
                  created: '2025-03-17T09:32:30.089Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'Hinweis: Die Terminbestätigung an Interessent:in wird automatisch versandt.',
                    enabled: true
                  },
                  sectionId: 'ahqdvkw5ff5',
                  type: 'STEP',
                  entityRefId: 'oxx5kuee089',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-03-17T09:32:30.089Z',
                  userIds: [],
                  name: 'Kontaktaufnahme mit Interessent:in für Terminvereinbarung Vor-Ort-Beratung - Datum in Feld "1. Vor-Ort-Termin" eintragen.',
                  id: 'oxx5kuee089',
                  definitionId: '_Y9T46UT',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    }
                  ],
                  startedTime: '2025-03-17T09:32:30.089Z',
                  journey: {
                    journeyId: '17c0bdc0-f9e1-11ef-af80-6f9ec310592a',
                    name: 'Photovoltaik-Anlage Teil 2 (Nachqualifizierung Vor-Ort-Termin)',
                    id: '7bbbe030-549c-4339-8d05-9d69272e152d'
                  },
                  created: '2025-03-17T09:32:30.089Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'In diesem Schritt ist eine Klickstrecke integriert, in der Sie die zusätzlichen Informationen und Fotos aus dem Vor-Ort-Termin der Opportunity hinzufügen können. Klicken Sie dafür auf "Photovoltaik-Anlage Teil 2 (Nachqualifizierung Vor-Ort-Termin)".',
                    enabled: true
                  },
                  sectionId: 'ahqdvkw5ff5',
                  type: 'STEP',
                  entityRefId: 'nuexz8drur4',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-03-17T09:32:30.089Z',
                  ecp: {
                    description:
                      'Für die weitere Planung ist es notwendig das Objekt vor Ort zu besichtigen.',
                    enabled: true,
                    label: 'Vor-Ort-Terminierung'
                  },
                  userIds: [],
                  name: 'Während des Vor-Ort-Termins: Zusätzliche Informationen und Fotos einholen - Daten über verknüpfte Klickstrecke hochladen.',
                  id: 'nuexz8drur4',
                  definitionId: 'xMh0jYAR',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    }
                  ],
                  startedTime: '2025-03-17T09:32:30.089Z',
                  journey: {
                    journeyId: '12af2240-f9e1-11ef-8c5c-615aa700ae94',
                    name: 'Allgemein - Uploads Vertrieb',
                    id: 'ab86fcbf-64df-4fc0-a164-d3e19b514036'
                  },
                  created: '2025-03-17T09:32:30.089Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'In diesem Schritt ist eine Klickstrecke integriert, in der Sie das Angebot übermitteln können. Klicken Sie dafür auf "Allgemein - Uploads Vertrieb".\n                                \nUploadkategorien:\n- Gebäudegrundriss\n- Zählerschrank\n- Zähler mit Zählernummer\n- möglicher Standort Wechselrichter/ Batteriespeicher\n- Dach\n- mögliche Verschattungen\n- Sonstiges\n',
                    enabled: true
                  },
                  sectionId: 'ahqdvkw5ff5',
                  type: 'STEP',
                  entityRefId: 'ntdtpx01su1',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-03-17T09:32:30.089Z',
                  ecp: {
                    enabled: false
                  },
                  userIds: [],
                  name: 'Dokumente/ Fotos aus Vor-Ort-Termin über verknüpfte Klickstrecke hochladen.',
                  id: 'ntdtpx01su1',
                  definitionId: 'ZmyKvhEM',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    }
                  ],
                  startedTime: '2025-03-17T09:32:30.089Z',
                  created: '2025-03-17T09:32:30.089Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  sectionId: 'ahqdvkw5ff5',
                  type: 'STEP',
                  entityRefId: 'lg8awj0a765',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-03-17T09:32:30.089Z',
                  userIds: [],
                  name: 'Opportunity und alle relevanten Entitäten über das Teilen Symbol (oben rechts) mit dem Partner teilen.',
                  id: 'lg8awj0a765',
                  definitionId: 'RvhUavum',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                }
              ],
              assignedTo: [],
              definitionId: 'j7eJh3wY',
              status: 'IN_PROGRESS',
              enabled: true
            },
            {
              name: 'Prüfungsphase Partner',
              id: '238rsgoc5qj',
              type: 'SECTION',
              steps: [
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    }
                  ],
                  startedTime: '2025-03-17T09:32:30.089Z',
                  created: '2025-03-17T09:32:30.089Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'Hinweis: Die Terminbestätigung an Interessent:in wird automatisch versandt.',
                    enabled: true
                  },
                  sectionId: '238rsgoc5qj',
                  type: 'STEP',
                  entityRefId: 'wlmg8sahcy0',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-03-17T09:32:30.089Z',
                  userIds: [],
                  name: 'Partner: optionale 2. Vor-Ort-Terminvereinbarung - Datum in Feld "2. Vor-Ort-Termin" eintragen. Falls nicht relevant, Schritt überspringen.',
                  id: 'wlmg8sahcy0',
                  definitionId: 'c36_ZWe9',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    }
                  ],
                  startedTime: '2025-03-17T09:32:30.089Z',
                  journey: {
                    journeyId: '129e8070-f9e1-11ef-b0df-bd572d7bccc6',
                    name: 'Allgemein - Uploads Partner',
                    id: 'bb2b8698-ced0-4a00-a8f2-1fd2f7785b73'
                  },
                  created: '2025-03-17T09:32:30.089Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'In diesem Schritt ist eine Klickstrecke integriert, in der Sie das Angebot übermitteln können. Klicken Sie dafür auf "Allgemein - Uploads Partner".',
                    enabled: true
                  },
                  sectionId: '238rsgoc5qj',
                  type: 'STEP',
                  entityRefId: 'qdbwgfxv213',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-03-17T09:32:30.089Z',
                  ecp: {
                    enabled: false
                  },
                  userIds: [],
                  name: 'Partner: Erstellung Angebot - Dokument über verknüpfte Klickstrecke hochladen.',
                  id: 'qdbwgfxv213',
                  definitionId: '7v_W2vaH',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                }
              ],
              assignedTo: [],
              definitionId: '-hj_-Fi3',
              status: 'OPEN',
              enabled: true
            },
            {
              name: 'Angebotsphase',
              id: '8jl7htcp3ie',
              type: 'SECTION',
              steps: [
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    }
                  ],
                  startedTime: '2025-03-17T09:32:30.089Z',
                  created: '2025-03-17T09:32:30.089Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  sectionId: '8jl7htcp3ie',
                  type: 'STEP',
                  entityRefId: 'th2fy3iibxq',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-03-17T09:32:30.089Z',
                  ecp: {
                    enabled: false
                  },
                  userIds: [],
                  name: 'Handwerker-Angebot überprüfen und auf Basis des Angebots eine Bestellung unter Gruppe "Bestellungen und Angebote" anlegen und speichern.',
                  id: 'th2fy3iibxq',
                  definitionId: 'p3Pgs00f',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    }
                  ],
                  startedTime: '2025-03-17T09:32:30.089Z',
                  created: '2025-03-17T09:32:30.089Z',
                  executionType: 'AUTOMATION',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'Hinweis: Sobald das finale Angebot an Interessent:in versandt wurde Automatisierung ausführen, um das Datum der Übermittlung in das entsprechende Feld zu übertragen.',
                    enabled: true
                  },
                  sectionId: '8jl7htcp3ie',
                  type: 'STEP',
                  entityRefId: 'bl5xzxwafl5',
                  automationConfig: {
                    flowId: '63067dc6-cfb0-44ff-8d3e-c18c0125abee'
                  },
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-03-17T09:32:30.089Z',
                  ecp: {
                    description:
                      'Wir planen aktuell Ihre individuelle Photovoltaik-Anlage.',
                    enabled: true,
                    label: 'Planung der Photovoltaik-Anlage'
                  },
                  userIds: [],
                  name: 'Email-Vorlage "PV - Finales Angebot inkl. Angebotsannahme" auswählen, erstelltes Angebot prüfen und E-Mail versenden.',
                  id: 'bl5xzxwafl5',
                  definitionId: 'OfHwI_qm',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    }
                  ],
                  startedTime: '2025-03-17T09:32:30.089Z',
                  created: '2025-03-17T09:32:30.089Z',
                  executionType: 'AUTOMATION',
                  assignedToInProgress: '-',
                  sectionId: '8jl7htcp3ie',
                  type: 'STEP',
                  entityRefId: 'c37rjzw6ewl',
                  automationConfig: {
                    flowId: '17d14f14-e97d-423d-b2e3-0bd37495b5f1'
                  },
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-03-17T09:32:30.089Z',
                  dynamicDueDate: {
                    stepId: 'OfHwI_qm',
                    timePeriod: 'days',
                    numberOfUnits: 7,
                    actionTypeCondition: 'STEP_CLOSED'
                  },
                  userIds: [],
                  name: 'Angebotsannahme erfolgt? Wenn "Nein" Automatisierungsschritt ausführen, um Reminder zu senden. Wenn "Ja", Schritt überspringen.',
                  id: 'c37rjzw6ewl',
                  definitionId: '5h5bw2yO',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '5h5bw2yO'
                    }
                  ],
                  startedTime: '2025-03-17T09:32:30.089Z',
                  created: '2025-03-17T09:32:30.089Z',
                  executionType: 'AUTOMATION',
                  assignedToInProgress: '-',
                  sectionId: '8jl7htcp3ie',
                  type: 'STEP',
                  entityRefId: 'qmd7ou2d20a',
                  automationConfig: {
                    flowId: 'fa1a0cbb-7e13-4dba-8900-fe58bee76995'
                  },
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-03-17T09:32:30.089Z',
                  ecp: {
                    description:
                      'Sind Sie mit dem unterbreiteten Angebot zufrieden?',
                    enabled: true,
                    label: 'Angebotsphase'
                  },
                  dynamicDueDate: {
                    stepId: '5h5bw2yO',
                    timePeriod: 'days',
                    numberOfUnits: 7,
                    actionTypeCondition: 'STEP_CLOSED'
                  },
                  userIds: [],
                  name: 'Angebotsannahme erfolgt? Wenn "Nein", Automatisierungsschritt ausführen, um Interessent:in über Prozessabbruch zu informieren - Prozess abbrechen und Abbruchgrund nennen. Wenn "Ja", Schritt überspringen.',
                  id: 'qmd7ou2d20a',
                  definitionId: 'HMTLIkea',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                }
              ],
              assignedTo: [],
              definitionId: 'nkelpCQ7',
              status: 'OPEN',
              enabled: true
            },
            {
              name: 'Vorbereitung Bereitstellung',
              id: 'mb29u1pn8j7',
              type: 'SECTION',
              steps: [
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '5h5bw2yO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'HMTLIkea'
                    }
                  ],
                  startedTime: '2025-03-17T09:32:30.089Z',
                  journey: {
                    journeyId: '12af2240-f9e1-11ef-8c5c-615aa700ae94',
                    name: 'Allgemein - Uploads Vertrieb',
                    id: 'ab86fcbf-64df-4fc0-a164-d3e19b514036'
                  },
                  created: '2025-03-17T09:32:30.089Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'In diesem Schritt ist eine Klickstrecke integriert, in der Sie die 1. Anzahlungsrechnung übermitteln können. Klicken Sie dafür auf "Allgemein - Uploads Vertrieb".',
                    enabled: true
                  },
                  sectionId: 'mb29u1pn8j7',
                  type: 'STEP',
                  entityRefId: 'x0ivh61p17f',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-03-17T09:32:30.089Z',
                  userIds: [],
                  name: 'ERP: 1. Anzahlungsrechnung erstellen: Rechnungsversand an Kund:in (1. Rechnung - Anzahlung) - Anzahlungsrechnung über verknüpfte Klickstrecke hochladen.',
                  id: 'x0ivh61p17f',
                  definitionId: 'dd7i4fmj',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '5h5bw2yO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'HMTLIkea'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dd7i4fmj'
                    }
                  ],
                  startedTime: '2025-03-17T09:32:30.089Z',
                  created: '2025-03-17T09:32:30.089Z',
                  executionType: 'AUTOMATION',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'Hinweis: Mit der Ausführung der Automatisierung wird das Datum der Beauftragung des Partners in das entsprechende Feld übertragen. Die Beauftragung des Partners ist in den weiteren informationen im nächsten Schritt vermerkt.',
                    enabled: true
                  },
                  sectionId: 'mb29u1pn8j7',
                  type: 'STEP',
                  entityRefId: 'x5c08x2lfyf',
                  automationConfig: {
                    flowId: '947bc1f7-f301-4b9e-8ea5-b42b41fb4f45'
                  },
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-03-17T09:32:30.089Z',
                  dynamicDueDate: {
                    stepId: 'dd7i4fmj',
                    timePeriod: 'days',
                    numberOfUnits: 7,
                    actionTypeCondition: 'STEP_CLOSED'
                  },
                  userIds: [],
                  name: 'Wiedervorlage: Zahlung eingegangen? Wenn "Ja", Automatisierungsschritt ausführen - Beauftragung des Partners über nachfolgende Aufgabe. Wenn "Nein", Kontaktaufnahme mit Kund:in und neue Frist auf T+7 setzen.',
                  id: 'x5c08x2lfyf',
                  definitionId: 'G8Y9cTif',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                }
              ],
              assignedTo: [],
              definitionId: '65Dt7ZS9',
              status: 'OPEN',
              enabled: true
            },
            {
              name: 'Installation inkl. Fertigstellung Partner',
              id: 'suvyo4fcqq6',
              type: 'SECTION',
              steps: [
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '5h5bw2yO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'HMTLIkea'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dd7i4fmj'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'G8Y9cTif'
                    }
                  ],
                  startedTime: '2025-03-17T09:32:30.089Z',
                  created: '2025-03-17T09:32:30.089Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'Finale Beauftragung für Installation der Photovoltaik-Anlage: \nKund:in hat das Angebot angenommen. Für die Antragstellung beim Netzbetreiber, sowie die weitere interne Organisation bitte die Widerrufsfrist beachten (siehe Feld Ende Widerrufsfrist)!\n',
                    enabled: true
                  },
                  sectionId: 'suvyo4fcqq6',
                  type: 'STEP',
                  entityRefId: 'nzrbkgk4f8s',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-03-17T09:32:30.089Z',
                  userIds: [],
                  name: 'Partner: Antragstellung beim Netzbetreiber',
                  id: 'nzrbkgk4f8s',
                  definitionId: 'bTVIdKd5',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '5h5bw2yO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'HMTLIkea'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dd7i4fmj'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'G8Y9cTif'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'bTVIdKd5'
                    }
                  ],
                  startedTime: '2025-03-17T09:32:30.089Z',
                  created: '2025-03-17T09:32:30.089Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  sectionId: 'suvyo4fcqq6',
                  type: 'STEP',
                  entityRefId: 'tov7v4pqkt4',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-03-17T09:32:30.089Z',
                  userIds: [],
                  name: 'Partner: Terminvereinbarung und Baubeginn (nach Widerrufsfrist) - Datum Baubeginn in Feld "Baubeginn" eintragen.',
                  id: 'tov7v4pqkt4',
                  definitionId: 'g3eVTm5t',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '5h5bw2yO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'HMTLIkea'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dd7i4fmj'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'G8Y9cTif'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'bTVIdKd5'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'g3eVTm5t'
                    }
                  ],
                  startedTime: '2025-03-17T09:32:30.089Z',
                  journey: {
                    journeyId: '129e8070-f9e1-11ef-b0df-bd572d7bccc6',
                    name: 'Allgemein - Uploads Partner',
                    id: 'bb2b8698-ced0-4a00-a8f2-1fd2f7785b73'
                  },
                  created: '2025-03-17T09:32:30.089Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'In diesem Schritt ist eine Klickstrecke integriert, in der Sie das Abnahmeprotokoll der Opportunity hinzufügen können. Klicken Sie dafür auf "Allgemein - Uploads Partner".',
                    enabled: true
                  },
                  sectionId: 'suvyo4fcqq6',
                  type: 'STEP',
                  entityRefId: 'eqe8ewn3xq9',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-03-17T09:32:30.089Z',
                  userIds: [],
                  name: 'Partner: Baumaßnahmen wurden fertiggestellt und abgenommen - Datum der Fertigstellung in Feld "Fertigstellung" eintragen - Abnahmeprotokoll über verknüpfte Klickstrecke hochladen.',
                  id: 'eqe8ewn3xq9',
                  definitionId: 'An4yz9pM',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '5h5bw2yO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'HMTLIkea'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dd7i4fmj'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'G8Y9cTif'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'bTVIdKd5'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'g3eVTm5t'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'An4yz9pM'
                    }
                  ],
                  startedTime: '2025-03-17T09:32:30.089Z',
                  journey: {
                    journeyId: '129e8070-f9e1-11ef-b0df-bd572d7bccc6',
                    name: 'Allgemein - Uploads Partner',
                    id: 'bb2b8698-ced0-4a00-a8f2-1fd2f7785b73'
                  },
                  created: '2025-03-17T09:32:30.089Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'In diesem Schritt ist eine Klickstrecke integriert, in der Sie die Dokumentation der Errichtung und der Inbetriebnahme der Opportunity hinzufügen können. Klicken Sie dafür auf "Allgemein - Uploads Partner".',
                    enabled: true
                  },
                  sectionId: 'suvyo4fcqq6',
                  type: 'STEP',
                  entityRefId: 'd7vq49ormsd',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-03-17T09:32:30.089Z',
                  ecp: {
                    enabled: true,
                    label: 'Installation inkl. Fertigstellung'
                  },
                  userIds: [],
                  name: 'Partner: Dokumentation der Errichtung und der Inbetriebnahme - Dokumente über verknüpfte Klickstrecke hochladen.',
                  id: 'd7vq49ormsd',
                  definitionId: 'oYLqfdHr',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '5h5bw2yO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'HMTLIkea'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dd7i4fmj'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'G8Y9cTif'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'bTVIdKd5'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'g3eVTm5t'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'An4yz9pM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'oYLqfdHr'
                    }
                  ],
                  startedTime: '2025-03-17T09:32:30.089Z',
                  journey: {
                    journeyId: '129e8070-f9e1-11ef-b0df-bd572d7bccc6',
                    name: 'Allgemein - Uploads Partner',
                    id: 'bb2b8698-ced0-4a00-a8f2-1fd2f7785b73'
                  },
                  created: '2025-03-17T09:32:30.089Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'In diesem Schritt ist eine Klickstrecke integriert, in der Sie die Schlussrechnung der Opportunity hinzufügen können. Klicken Sie dafür auf "Allgemein - Uploads Partner".',
                    enabled: true
                  },
                  sectionId: 'suvyo4fcqq6',
                  type: 'STEP',
                  entityRefId: 'pcst3vtmlqj',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-03-17T09:32:30.089Z',
                  ecp: {
                    enabled: false
                  },
                  userIds: [],
                  name: 'Partner: Schlussrechnung erstellen - Schlussrechnung über verknüpfte Klickstrecke hochladen.',
                  id: 'pcst3vtmlqj',
                  definitionId: 'PnKp6bGK',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                }
              ],
              assignedTo: [],
              definitionId: 'OgeUHFyc',
              status: 'OPEN',
              enabled: true
            },
            {
              name: 'Abschluss',
              id: '1p3n94p27ej',
              type: 'SECTION',
              steps: [
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '5h5bw2yO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'HMTLIkea'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dd7i4fmj'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'G8Y9cTif'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'bTVIdKd5'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'g3eVTm5t'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'An4yz9pM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'oYLqfdHr'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'PnKp6bGK'
                    }
                  ],
                  startedTime: '2025-03-17T09:32:30.089Z',
                  journey: {
                    journeyId: '12af2240-f9e1-11ef-8c5c-615aa700ae94',
                    name: 'Allgemein - Uploads Vertrieb',
                    id: 'ab86fcbf-64df-4fc0-a164-d3e19b514036'
                  },
                  created: '2025-03-17T09:32:30.089Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'In diesem Schritt ist eine Klickstrecke integriert, in der Sie die Schlussrechnung der Opportunity hinzufügen können. Klicken Sie dafür auf "Allgemein - Uploads Vertrieb".',
                    enabled: true
                  },
                  sectionId: '1p3n94p27ej',
                  type: 'STEP',
                  entityRefId: '0fh7b7nh4sb',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-03-17T09:32:30.089Z',
                  ecp: {
                    enabled: true,
                    label: 'Abschluss'
                  },
                  userIds: [],
                  name: 'ERP: Schlussrechnung an Kund:in senden - Schlussrechnung über verknüpfte Klickstrecke hochladen.',
                  id: '0fh7b7nh4sb',
                  definitionId: '76QWWDEa',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                }
              ],
              assignedTo: [],
              definitionId: '8vvcDG0J',
              status: 'OPEN',
              enabled: true
            }
          ],
          configuredClosingReasonSnapshot: [
            {
              title: 'Keine Angabe von Gründen',
              id: 'i2zo9gPVRCNJ8m2Gtk6uZ'
            },
            {
              title: 'Keine Rückmeldung vom Kunden',
              id: 'aqKPeWx8dcCuU0X3oDq2B'
            },
            {
              title: 'Zeitlich nicht passend',
              id: 'wOWVIQVEchhpL3w416UnM'
            },
            {
              title: 'Zu lange Wartezeit',
              id: 'CjvH587V_MDu5IODwPf1h'
            },
            {
              title: 'Kosten zu hoch',
              id: '8R_cjx8-2mPkI-iCj_hZN'
            },
            {
              title: 'Wirtschaftlichkeit',
              id: '7jaqGtHPkrlpKWspphQSt'
            },
            {
              title: 'Entscheidung für Mitbewerber',
              id: 'w0yyCm-IAsPGxd2hsIvAC'
            },
            {
              title: 'Dach zu alt',
              id: 'NJjMgeq6P-qK5ZHNPZcjV'
            }
          ],
          contexts: [
            {
              schema: 'order',
              title: 'OR-5136',
              id: '7c84255d-e479-4624-b589-8ed4d327ed30'
            }
          ],
          orgId: '739224',
          definitionId: 'wfwYDzFIEc',
          id: 'ic6cb1w41ul'
        }
      ],
      journey_actions: []
    }
  ]
}
